import React from "react";
import MovieList from "./MovieList";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { motion } from "framer-motion";

const SecondaryContainer = () => {
  const movies = useSelector((store: RootState) => store.movies);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.6, ease: "easeOut" } }
  };

  return (
    <div className="relative z-30 bg-gradient-to-t from-black via-[#0a0a0a] to-transparent">
      <div className="px-4 md:px-12 pb-24 md:-mt-40">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="space-y-4 md:space-y-8"
        >
          {movies.trendingMovies && (
            <motion.div variants={itemVariants}>
              <MovieList title={"Trending Now"} movies={movies.trendingMovies} />
            </motion.div>
          )}
          {movies.nowPlayingMovies && (
            <motion.div variants={itemVariants}>
              <MovieList title={"Now Playing"} movies={movies.nowPlayingMovies} />
            </motion.div>
          )}
          {movies.popularMovies && (
            <motion.div variants={itemVariants}>
              <MovieList title={"Global Top Hits"} movies={movies.popularMovies} />
            </motion.div>
          )}
          {movies.upcomingMovies && (
            <motion.div variants={itemVariants}>
              <MovieList title={"Anticipated Releases"} movies={movies.upcomingMovies} />
            </motion.div>
          )}
          {movies.topRatedMovies && (
            <motion.div variants={itemVariants}>
              <MovieList title={"Critically Acclaimed"} movies={movies.topRatedMovies} />
            </motion.div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default SecondaryContainer;
